<template>
  <ul id="language_switcher">
    <li v-for="locale in locales" :key="locale" @click="switchLocale(locale)" :class="locale == $i18n.locale ? 'active' : ''">{{ locale }}</li>
  </ul>
</template>

<script>
export default {
  name: "LanguageSwitcher",
  data() {
    return {
      locales: ['fr', 'nl']
    }
  },
  methods: {
    switchLocale(locale) {
      this.$i18n.locale = locale;
    }
  }
};
</script>



// WEBPACK FOOTER //
// LanguageSwitcher.vue?bfa9aa86